import React from "react";
import { useState } from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";

const OfferCard = ({ offer, isExpanded, onExpand }) => {
  const [params] = useSearchParams();
  const [showDefaultOfferPopup, setShowDefaultOfferPopup] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const proceedWithOffer = async () => {
    setUserClickData({
      event_name: `offer-apply-button-offer-check-v2-consent-${offer.lender_name}`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
    });
    setUserClickData({
      event_name: `offer-apply-button-offer-check-v2`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
    });

    window.location.href = `${offer.app_url}`;
  };

  const handleClick = () => {
    if (isProtium) {
      setShowDefaultOfferPopup(true);
    } else {
      setUserClickData({
        event_name: `offer-apply-button-offer-check-v2-${offer.lender_name}`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
        utm_source: params.get("utm_source") || "",
      });
      setUserClickData({
        event_name: `offer-apply-button-offer-check-v2`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
        utm_source: params.get("utm_source") || "",
      });

      window.location.href = `${offer.app_url}`;
    }
  };

  const isProtium = offer.lender_id === "662752eb65fdba1a48d6e47c";
  const isLNT = offer.lender_id === "662752eb65fdba1a48d6e482";
  const horizontalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_hl || offer.logo_image_url;

  const verticalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_vl || offer.logo_image_url;

  return (
    <>
      {showDefaultOfferPopup && isProtium && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg max-h-[90vh] flex flex-col">
            <h2 className="text-xl font-semibold mb-4">
              Do you want to proceed with Protium for a personal loan?
            </h2>

            {/* Scrollable Content */}
            <div
              className="overflow-y-auto pr-2 mb-4 text-sm text-gray-700"
              style={{ maxHeight: "50vh" }}
            >
              <div className="mb-4">
                <p className="mb-2">
                  You are deemed to have full and adequate authority/legal
                  competency to submit the application and relevant documents
                  for availing the loan from Protium Finance Limited
                  (“Protium”).
                </p>
                <p className="mb-2">
                  You authorize Protium or its agents/representatives to use the
                  documents and personal information provided by you to conduct
                  credit reference checks by extracting additional information
                  from various third-party sources (including but not limited
                  to) like credit bureaus, government agencies, banks, CERSAI
                  etc. You authorize Protium to use the same information to
                  conduct further checks for any additional loans in the future
                  and ongoing review. You also authorize Protium to share the
                  application details to other regulated entities or co-lenders
                  at its own discretion.
                </p>
                <p className="mb-2">
                  You authorize Protium for communication with you on any mode
                  (telephone calls/SMS/messaging services like WhatsApp, emails
                  etc.) with respect to revisions in terms & conditions and/or
                  new services/offers from Lender. Further, any acceptance by
                  you from the mobile number(s) and Email ID(s) provided by you
                  will be binding in nature.
                </p>
                <p className="mb-2">
                  You confirm that laws concerning the unsolicited communication
                  referred in “National Do Not Call Registry” (the “NDNC
                  Registry”) will not be applicable for such communication
                  received from Protium and/or associates.
                </p>

                {/* Checkbox moved below */}
                <div className="flex items-start mt-4">
                  <input
                    type="checkbox"
                    id="authorizeCheckbox"
                    className="mt-1 mr-2"
                    checked={isAuthorized}
                    onChange={(e) => setIsAuthorized(e.target.checked)}
                  />
                  <label htmlFor="authorizeCheckbox" className="text-gray-700">
                    You confirm to have read and accepted the declaration
                    mentioned at{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvcHJpdmFjeS1wb2xpY3kv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=L1BWRi96ek1rMVFlWGkyWjdoVEY1VnpGZnpCWnBmQ3M0MmFEOFdtWXN4OD0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvdGVybXMtYW5kLWNvbmRpdGlvbnMv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=UVIra0R0NnNIOG9TUldIUkk4Z0ZBVnB5NEtoUHpnSERWVzZHQmJGekNRZz0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&amp;C
                    </a>
                    .
                  </label>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-auto">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setShowDefaultOfferPopup(false)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 rounded text-white ${
                  isAuthorized
                    ? "bg-blue-600"
                    : "bg-blue-300 cursor-not-allowed"
                }`}
                disabled={!isAuthorized}
                onClick={() => {
                  setShowDefaultOfferPopup(false);
                  proceedWithOffer();
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="offer-card-section">
        <div
          className={`offer-card ${isExpanded ? "expanded" : "collapsed"}`}
          onClick={onExpand}
        >
          {isExpanded && (
            <>
              <img src={horizontalLogo} className="lender-logo" alt="Lender" />
            </>
          )}

          <div className="offer-details">
            {isExpanded && <hr className="offer-divider" />}

            {isExpanded ? (
              <>
                <div className="amount-row">
                  <span className="amount-label">
                   {"Max Loan Amount: "}
                  </span>
                  <span className="amount-value">
                    {" "}
                    upto ₹{offer.credit_limit}
                  </span>
                </div>
              </>
            ) : (
              <div className="amount-row">
                <img src={verticalLogo} className="lender-logo" alt="Lender" />
                <div>
                  <span className="amount-label">
                   {"Max Loan Amount: "}
                  </span>
                  <br />
                  <span className="amount-value">
                    {" "}
                    upto ₹{offer.credit_limit}
                  </span>
                </div>
              </div>
            )}

            {isExpanded && <hr className="offer-divider" />}

            {isExpanded && (
              <>
                <>
                  <div className="emi-row">
                    Tenure: {48 || offer.tenure} Months
                  </div>
                  {isExpanded && <hr className="offer-divider" />}
                  {offer.interest_rate && (
                    <>
                      <span className="emi-row">
                        Interest Rate: {offer.interest_rate}
                      </span>
                    </>
                  )}

                  {isExpanded && <hr className="offer-divider" />}
                  {offer.processing_fee && (
                    <div className="w-full text-center pb-2">
                      <span className="emi-row">
                        Processing Fees: {offer.processing_fee}
                      </span>
                    </div>
                  )}
                </>

                {isExpanded && offer.processing_fee && (
                  <hr className="offer-divider" />
                )}

                <div className="loan-extra-details mt-3 text-sm text-gray-700">
                  {offer.apr && (
                    <div className="flex justify-between mb-1 font-semibold">
                      <span className="font-semibold text-gray-800">APR:</span>
                      <span>{offer.apr}</span>
                    </div>
                  )}

                  {offer.penal_charges && (
                    <div className="flex justify-between mb-1 font-semibold">
                      <span className="font-semibold text-gray-800">
                        Penal Charges:
                      </span>
                      <span>{offer.penal_charges}</span>
                    </div>
                  )}

                  {offer.kfs_doc && (
                    <div className="flex items-center justify-between mt-2 font-semibold">
                      <span className=" text-gray-800 font-semibold">
                        View KFS:
                      </span>
                      <a
                        href={offer.kfs_doc}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-green-700 font-semibold hover:underline"
                      >
                        <FileText className="w-4 h-4 mr-1" />
                        Document
                      </a>
                    </div>
                  )}
                </div>

                <button
                  className="get-offer-btn tracking-get-offer-btn-v5"
                  // id={`btn-get-offer-${
                  //   offer.lender_name?.toLowerCase().replace(/\s+/g, "-") ||
                  //   "unknown"
                  // }-v5`}
                  id={`btn-get-offer-v5`}
                  onClick={handleClick}
                >
                  {" "}
                  Get Offer{" "}
                  <img
                    src="/assets/img/Get offer CTA icon.svg"
                    alt="Arrow"
                    className="cta-icon"
                  />
                </button>
              </>
            )}
          </div>

          {!isExpanded && (
            <img
              src="/assets/img/offers arrow.svg"
              className="collapse-arrow"
              alt="Expand"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default OfferCard;
